module.exports = __webpack_public_path__ + "img/pwa-notifications-desktop-standalone-1.918b2536.png";